import React from "react";
import { useSelector } from "react-redux";
import {
  ExpandMoreOutlined,
  NotificationsOutlined,
  Search,
} from "@mui/icons-material";
import { Avatar, Box, IconButton, Stack,Typography } from "@mui/material";
import { UserRoles } from 'src/constants/user';

import { UsFlagIcon } from "../../Icons";

export const NavBar = () => {
  const { user } = useSelector((state: any) => state.auth);
  const fullname = `${user?.firstName} ${user?.lastName}`;
  // @ts-ignore
  const role = UserRoles[user?.role];

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      paddingX={4}
      paddingY={2.2}
      sx={{
        borderBottom: "1px solid #E8E8E8",
        backgroundColor: "white",
      }}
    >
      <Stack direction="row" spacing={2}>
        <Avatar variant="rounded" src={user?.photo} />
        <Box display="flex" flexDirection="column" alignItems="flex-start">
          <Typography fontSize={16} fontWeight="500" color="#1F1F1F">
            {fullname}
          </Typography>
          <Typography fontSize={14} color="#1F1F1F">
            {role}
          </Typography>
        </Box>
      </Stack>

      {/* ICONS */}
      <Stack
        //@todo until better time
        sx={{ display: "none" }}
        direction="row"
        alignItems="center"
        spacing={3}
      >
        <IconButton type="button" sx={{ p: 1 }}>
          <Search />
        </IconButton>
        <IconButton>
          <NotificationsOutlined />
        </IconButton>
        <IconButton>
          <Stack direction="row" alignItems="center" spacing={1}>
            <UsFlagIcon />
            <Typography fontSize={14} color="#000">
              EN
            </Typography>
            <ExpandMoreOutlined />
          </Stack>
        </IconButton>
      </Stack>
    </Box>
  );
};
